module.exports = __webpack_public_path__ + "static/media/hero.634df947.png";